import {
  UNIDADES,
  SENTIDOS,
  TIPO_ACTUACION_JARDINERIA,
  LOCALIZACION_JARDINERIA_TRONCO
} from './selectOptions'

import comunValidacionFormFields from './comunValidacionFormFields'

export const identificacion = (workOrderFragment, familyFragment) => [
  {
    label: 'Comentarios',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'identificacion',
      'comentarios'
    ]
  }
]

export const inspeccion = (workOrderFragment, familyFragment) => [
  {
    label: 'PK Inicio',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'inspeccion',
      'pkInicio'
    ]
  },

  {
    label: 'PK Fin',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'inspeccion',
      'pkFin'
    ]
  },

  {
    label: 'Altura media hierba',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'inspeccion',
      'alturaMediaHierba'
    ]
  },

  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'inspeccion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'inspeccion',
      'observaciones'
    ]
  },

  {
    label: 'Fotos antes',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'inspeccion',
      'antesFotos'
    ],
    meta: { isPhotos: true }
  }
]

export const ejecucion = (workOrderFragment, familyFragment) => [
  {
    label: 'Tipo de actuación',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'tipoActuacion'
    ],
    meta: {
      options: TIPO_ACTUACION_JARDINERIA
    }
  },

  {
    label: 'PK Inicio',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'pkInicio'
    ]
  },

  {
    label: 'PK Fin',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'pkFin'
    ]
  },

  {
    label: 'Coordenadas PK Inicio',
    type: 'Coordinates',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'coordenadasPkInicio'
    ]
  },

  {
    label: 'Coordenadas PK Fin',
    type: 'Coordinates',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'coordenadasPkFin'
    ]
  },

  {
    label: 'Sentido',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'sentido'
    ],
    meta: {
      options: SENTIDOS
    }
  },

  {
    label: 'Localización',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'localizacion'
    ],
    meta: {
      options: LOCALIZACION_JARDINERIA_TRONCO
    }
  },

  {
    label: 'Medición',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'medicion'
    ]
  },

  {
    label: 'Unidad',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'unidad'
    ],
    meta: {
      options: UNIDADES
    }
  },

  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'observaciones'
    ]
  },

  {
    label: 'Fotos despues',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'jardineriasTronco',
      familyFragment,
      'ejecucion',
      'despuesFotos'
    ],
    meta: { isPhotos: true }
  }
]

export const validacion = comunValidacionFormFields('jardineriasTronco')
